<template>
    <div id="print" v-if="!isEmpty(listCourseQuestion)" class="big_cat_screen"  @touchmove="touchmove" :style="{'background-color': '#' + currentCourseQuestion.backgroundColor}">
        <div class="back_nav" @click="goToBack"><img src="@/assets/back_nav.png"/></div>
        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>认知游戏</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isPlayingFail" class="playing_fail" @click="playCAudio()">
            <img src="@/Images/icon_replay.png" />
        </div>

        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" :style="{top:'20px', right:'30px'}"><img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span></div>
        <audio class="audio" :src="starAudio" id="star_audio" @ended="playEnded('star_audio')" @error="playEnded('star_audio')" />

        <!-- 题目 -->
        <div class="c_question_content" @click="playCAudio()">
            <div class="c_audio_play">
                <div class="audio_playing_game img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/Images/audio_game3.png" height="40px" width="40px"/>
            </div>
            <div class="c_content" v-html="getQuestionText()">
            </div>
        </div>

        <!-- 选项 -->
        <div class="option_main">
            <div class="c_option">
                <div class="c_option_img_item" v-for="(item,index) in currentCourseQuestion.optionArray" :key="index" @click="optionClick(item, index)">
                    <img class="lazy_img" v-lazy="$qiNiuDomainBase + item.picture" />
                    <div :id="'cc_error_' + index" class="c_error"><img src="@/assets/error.png"/></div>
                    <div :id="'cc_success_' + index" class="c_success"><img src="@/assets/success.png"/></div>
                </div>
            </div>
        </div>
        <audio v-show="false" :src="ccAudioUrl" id="cc_musicMp3" @ended="playEndedForNext('cc_musicMp3')" @error="playEnded('cc_musicMp3')" />

        <audio class="audio" :src="ccErrorAudio" id="cc_error_audio" style="display: none" @ended="playEnded('cc_error_audio')" @error="playEnded('cc_error_audio')" controls=""/>
        <audio class="audio" :src="ccSuccessAudio" id="cc_success_audio" style="display: none" @ended="playEnded('cc_success_audio')" @error="playEnded('cc_success_audio')" controls=""/>
        <div class="common_question_left" @click="handBackQuestionClick" style="display: none"><img src="../../assets/question_left.png"/></div>
        <div class="common_question_right" @click="handNextQuestion"><img src="../../assets/question_right.png"/></div>
    </div>

</template>

<script>
    import Vue from 'vue'
    import $ from "jquery";
    import Utils from "@/pages/Program/util2";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vh - 60px)");
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vw - 60px)");
        }
    }

    export default {
        name: "pchoicequestion",
        data() {
            return {
                lessonId: 0,
                questionIndex: 0,
                listCourseQuestion: [],
                currentCourseQuestion:null,
                ccErrorAudio: "https://img.xiaohuasheng.cn/error_tip.mp3",
                ccSuccessAudio: "https://img.xiaohuasheng.cn/success.mp3",
                ccAudioUrl: "",
                nextQuestionType: 0,
                showExitConfirm: 0,
                starAudio:null,
                starCount:0,
                showStarTransition:false,
                totalStarCount:0,
                choiceQuestionError:0,
                showTransition:false,
                questionAudioEnd:0,
                successIndex:0,
                isPlaying: false,
                isPlayingFail: false,
            }
        },
        methods: {
            goToBack() {
                this.showExitConfirm = 1;
            },
            nextPageClick: function () {
                this.$router.replace({name: "PDropQuestion", query: {lessonId: this.lessonId, type: 2}});
            },
            touchmove(e) {
                e.preventDefault();
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            playEndedForNext(idMusicmp3) {
                this.playEnded(idMusicmp3);
                this.isPlaying = false;

                if (this.questionAudioEnd === 1) {
                    this.questionAudioEnd = 0;
                    $("#cc_success_" + this.successIndex).hide();
                    this.successIndex = 0;
                    this.autoNextQuestion();
                }
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            getQuestionText() {
                if (this.isEmpty(this.currentCourseQuestion.text)) {
                    return;
                }

                let vWordLength = 0;

                for (let i = 0; i < this.currentCourseQuestion.optionArray.length; i++) {
                    let vOption = this.currentCourseQuestion.optionArray[i];

                    if (this.getCount(vOption.isRightAnswer) === 1) {
                        vWordLength = vOption.text.length;
                    }
                }

                return this.currentCourseQuestion.text.replace(/\*/g,
                    "<span id='question_letter' style='border-bottom: 2px solid white; display: inline-block; height:28px; vertical-align: middle;" +
                    " width:" + vWordLength * 14 + "px; margin-left: 5px; margin-right: 5px; text-align: center; font-size: 22px; font-weight: bold; color:#FFFFFF;line-height:28px'></span>");
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            playErrorAudio() {
                const ccErrorAudio = document.getElementById('cc_error_audio');
                ccErrorAudio.play();
            },
            playSuccessAudio() {
                const ccSuccessAudioPlay = document.getElementById('cc_success_audio');
                ccSuccessAudioPlay.play();
            },
            optionClick:function(objQuestionOption, index){
                let that = this;

                if (that.questionAudioEnd === 1) {
                    return;
                }

                let isRightAnswer = that.getCount(objQuestionOption.isRightAnswer);

                // 0不是正确答案/1是正确答案
                if (isRightAnswer === 0) {
                    that.playErrorAudio();
                    $("#cc_error_" + index).show();
                    that.choiceQuestionError += 1;

                    setTimeout(function () {
                        $("#cc_error_" + index).hide();
                    }, 500);
                    return;
                }

                that.playSuccessAudio();
                $("#question_letter").html(objQuestionOption.text);
                $("#cc_success_" + index).show();

                setTimeout(function () {
                    let vStarCount = 3;

                    if (that.choiceQuestionError === 1) {
                        vStarCount = 2;
                    } else if(that.choiceQuestionError > 1) {
                        vStarCount = 1;
                    }

                    // 显示星星
                    that.showStarView(vStarCount);

                    // 完成这一题记录在本地
                    that.listCourseQuestion.forEach((item, index) => {
                        if (that.questionIndex === index) {
                            item.finished = 1;
                            Vue.set(that.listCourseQuestion, index, item);
                        }
                    });

                    // 过2.5秒跳转到下一步
                    setTimeout(function () {
                        that.questionAudioEnd = 1;
                        that.successIndex = index;
                        that.playCAudio();
                    }, 2300);
                }, 800);
            },
            handBackQuestionClick:function() {
                let that = this;

                that.questionAudioEnd = 0;
                $("#cc_success_" + that.successIndex).hide();
                that.successIndex = 0;
                that.choiceQuestionError = 0;
                $("#question_letter").html("");

                that.questionIndex -= 1;

                // 返回按钮
                if (that.questionIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.nextQuestionType === 0 && that.questionIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }

                that.initData();
            },
            handNextQuestion() {
                this.questionAudioEnd = 0;
                $("#cc_success_" + this.successIndex).hide();
                this.successIndex = 0;
                this.autoNextQuestion();
            },
            autoNextQuestion() {
                let that = this;
                that.choiceQuestionError = 0;
                that.nextQuestionClick();
            },
            showStarView(count) {
                let that = this;

                that.starCount = count;
                that.starAudio = that.getProgramAudioUrl(that.starCount);
                that.showStarTransition = true;

                setTimeout(() => {
                    for(let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*350, function(){
                            if (i === 3) {
                                setTimeout(() => {
                                    that.showStarTransition = false;
                                    let starAnimation = $(".star_animation");
                                    starAnimation.show();
                                    starAnimation.animate({top:"20px", right:that.currentCourseQuestion.type === 2 ? '175px' : '30px'}, 500,function(){
                                        starAnimation.hide();
                                        starAnimation.css({top:"", right:""});
                                    });
                                    that.addStar(that.starCount);
                                }, 800);
                            }
                        });
                    }

                    let audioPlayer = document.getElementById('star_audio');

                    if (audioPlayer != null) {
                        audioPlayer.play();
                    }
                }, 200);
            },
            addStar(count) {
                let that = this;
                let url = "englishProgram/addStar/" + that.lessonId + "/" + count;
                this.$axios.get(url).then((response) => {
                    that.totalStarCount = parseInt(response.data);
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            nextQuestionClick: function () {
                let that = this;
                $("#question_letter").html("");
                that.questionIndex += 1;

                // 返回按钮
                if (that.questionIndex <= 0) {
                    $(".common_question_left").hide();
                } else {
                    $(".common_question_left").show();
                }

                // 下一步按钮
                if (that.nextQuestionType === 0 && that.questionIndex >= that.listCourseQuestion.length - 1) {
                    $(".common_question_right").hide();
                } else {
                    $(".common_question_right").show();
                }

                if (that.questionIndex >= that.listCourseQuestion.length) {
                    let unfinished = that.getUnfinished();

                    // 7字母题/8跟读题
                    if (that.nextQuestionType === 7) {
                        this.$router.replace({name: "pLetterQuestion", query: {lessonId: this.lessonId, unfinished: unfinished}});
                    } else if (that.nextQuestionType === 8) {
                        this.$router.replace({name: "PFollow", query: {lessonId: this.lessonId, unfinished: unfinished}});
                    } else {
                        that.showFinishTransition();
                    }

                    return;
                }

                that.initData();
            },
            getUnfinished() {
                let that = this;
                let unfinished = 0;

                that.listCourseQuestion.forEach((item, index) => {
                    window.console.log("是否完成题目" + index + ":" + item.finished)

                    if (that.getCount(item.finished) === 0) {
                        unfinished = 1;
                    }
                });

                return unfinished;
            },
            initData:function () {
                let that = this;

                that.currentCourseQuestion = that.listCourseQuestion[that.questionIndex];
                that.ccAudioUrl = "";

                if (!that.isEmpty(that.currentCourseQuestion.audio)) {
                    that.ccAudioUrl = that.$qiNiuDomainBase + that.currentCourseQuestion.audio;

                    setTimeout(() => {
                        that.playCAudio();
                    }, 200);
                }
            },
            showFinishTransition() {
                let that = this;
                that.showTransition = true;
                let unfinished = that.getUnfinished();

                if (unfinished === 0) {
                    Utils.$emit('setStarCount','5');
                }
            },
            playCAudio() {
                let that = this;

                if (that.isEmpty(that.ccAudioUrl)) {
                    return;
                }

                that.isPlayingFail = false;
                let ccmusicMp3 = document.getElementById('cc_musicMp3');
                ccmusicMp3.src = that.ccAudioUrl;
                that.isPlaying = true;

                setTimeout(() => {
                    let playPromise = ccmusicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);
                            that.isPlayingFail = true;

                            if (!that.isEmpty(vError) && vError !== "{}") {
                                that.isPlaying = false;
                                window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 300);
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "/englishProgram/getGameQuestion3/" + vLessonId + "/" + 1;

            that.$axios.get(url).then((response) => {
                that.nextQuestionType = response.data.nextQuestionType;
                that.listCourseQuestion = response.data.questionList;
                that.currentCourseQuestion = that.listCourseQuestion[that.questionIndex];
                that.totalStarCount = parseInt(that.currentCourseQuestion.totalStarCount);
                that.lessonId = vLessonId;

                that.hideStatusAndStopAudio();

                if (!that.isEmpty(that.listCourseQuestion)) {
                    let vCourseQuestion = that.listCourseQuestion[0];

                    if (that.isEmpty(vCourseQuestion.audio)) {
                        that.ccAudioUrl = "";
                    } else {
                        that.ccAudioUrl = that.$qiNiuDomainBase + vCourseQuestion.audio;

                        setTimeout(() => {
                            that.playCAudio();
                        }, 200);
                    }
                }

                setTimeout(() => {
                    transformView();
                }, 100);

            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .option_main {
        position: absolute;
        width: 100%;
        bottom: 50px;
    }
    .c_option {
        margin-left: calc((100vmax - 100vmin)/3);
        margin-right: calc((100vmax - 100vmin)/3);
        display: flex;
        justify-content: space-between;
    }
    .c_option .c_option_img_item {
        display: inline-flex;
        position: relative;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .c_option .c_option_img_item .lazy_img {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: 36vmin;
        height: 42vmin;
    }
    .c_option_img_item .c_error {
        position: absolute;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        width: 36vmin;
        height: 42vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_error img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .c_option_img_item .c_success {
        position: absolute;
        background-color: rgba(47,205,0,0.8);
        width: 36vmin;
        height: 42vmin;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: none;
    }
    .c_option_img_item .c_success img {
        position: absolute;
        width: 50%;
        height: auto;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }

    .c_question_content {
        position: absolute;
        display: flex;
        align-items: center;
        max-width: calc(100vmax/3.0 + 200vmin/3.0);
        min-height: 20vmin;
        padding-bottom: 5px;
        padding-top: 5px;
        top: 50px;
        margin-left: calc((100vmax - 100vmin)/3);
        background-color: #00000039;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .c_question_content .c_audio_play .img_play {
        width: 40px;
        height: 40px;
    }
    .c_question_content .c_audio_play {
        position: relative;
        display: flex;
        z-index:600;
        margin-left: 20px;
    }
    .c_question_content .c_audio_play img {
        width: 40px;
        height: 40px;
    }
    .c_question_content .c_content {
        position: relative;
        z-index:599;
        min-width: 60vmin;
        line-height: 30px;
        padding-top: 8px;
        padding-bottom: 8px;
        /*display: flex;*/
        /*align-items: center;*/
        padding-left: 10px;
        padding-right: 30px;
        font-size: 22px;
        font-weight: bold;
        color: white;
        font-family: Arial;
    }
    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }
    .big_cat_screen .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .big_cat_screen .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .big_cat_screen .transition .content2 {
        text-align: center;
    }

    .big_cat_screen .transition .content3 {
        text-align: center;
    }
    .big_cat_screen .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .big_cat_screen .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .big_cat_screen .transition .content .text span {
        display: block;
        text-align: center;
    }
    .big_cat_screen .transition .content .text .success_tip {
        font-size: 24px;
    }
    .big_cat_screen .transition .content .star {
        height: 35px;
    }
    .big_cat_screen .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .big_cat_screen .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .big_cat_screen .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
    .navigation .left i {
        background-color: #0000005a;
        border-radius: 22px;
        font-size: 18px;
        padding: 5px;
    }

</style>
